module.exports = __webpack_public_path__ + "img/yikh_logo.a8259573.png";